import { render, staticRenderFns } from "./aPickupBookingPaceWeekly.vue?vue&type=template&id=2772bd58"
import script from "./aPickupBookingPaceWeekly.vue?vue&type=script&lang=js"
export * from "./aPickupBookingPaceWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports